import { useConfigStore } from '@fides/fides-react-components';
import React from 'react';
import FetchPortalUrl from './app/api/fetch-components/FetchPortalUrl';
export interface AppStartupProps {
  children: React.ReactNode;
}

export function AppStartup(props: AppStartupProps) {
  return (
    <FetchPortalUrl>
      {(portalUrl) => (
        <>
          <StorePortalUrl portalUrl={portalUrl} />
          {props.children}
        </>
      )}
    </FetchPortalUrl>
  );
}

export function StorePortalUrl(props: { portalUrl: string }) {

  React.useEffect(() => {
    useConfigStore.setState({ portalUrl: props.portalUrl })
  }, [ props.portalUrl]);

  return null;
}
